import type { ReactNode } from "react";
import cx from "classnames";
import riskDangerIcon from "@/assets/images/risk-danger.svg";
import riskSuspiciousIcon from "@/assets/images/risk-suspicious.svg";
import riskTrustedIcon from "@/assets/images/risk-trusted.svg";
import riskSanctionsIcon from "@/assets/images/risk-sanctions.svg";
import { RiskDetailsItem } from "./RiskDetailsItem";
import { CATEGORY_LABELS, type RiskDetails, type RiskType } from "@/config";
import styles from "./RiskDetailsCategory.module.sass";

interface RiskDetailsCategoryProps {
  category: string;
  risks: RiskDetails[];
  children?: ReactNode;
}

const RISK_ICONS: Record<string, string> = {
  danger: riskDangerIcon,
  suspicious: riskSuspiciousIcon,
  trusted: riskTrustedIcon,
  sanctions: riskSanctionsIcon,
};

export const RiskDetailsCategory = ({
  category,
  risks = [],
  children,
}: RiskDetailsCategoryProps) => {
  const riskIcon = RISK_ICONS[category];
  const categoryLabel = CATEGORY_LABELS[category] || category;

  const classes = cx(styles.category, styles[`category--${category}`]);

  return (
    <div className={classes}>
      <div className={styles.head}>
        <div className={styles.title}>
          {riskIcon && (
            <img src={riskIcon} alt={category} className={styles.icon} />
          )}
          <span className={styles.name}>{categoryLabel}</span>
        </div>
        <span className={styles.spacer} />
      </div>
      <div className={styles.items}>
        {risks.map((risk) => (
          <RiskDetailsItem
            key={risk.label}
            type={category as RiskType}
            label={risk.label}
          />
        ))}
      </div>
      {children}
    </div>
  );
};
